import ForgetPasswordBox from './index.vue'

ForgetPasswordBox.install = function (Vue) {
  Vue.component(ForgetPasswordBox.name, ForgetPasswordBox)
}

export default ForgetPasswordBox